import {
  MA_MARKETPLACE_LIST_ERROR,
  MA_MARKETPLACE_LIST_SUCCESS,
  MA_MARKETPLACE_LIST_REQUEST,
} from "./constants";

const initialState = {
  loading: false,
  data: [],
};

export default function maMarketplaceListReducer(state = initialState, action) {
  switch (action.type) {
    case MA_MARKETPLACE_LIST_REQUEST:
      return { ...state, loading: true };
    case MA_MARKETPLACE_LIST_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case MA_MARKETPLACE_LIST_ERROR:
      return { ...state, loading: false };

    default:
      return state;
  }
}
